<template>
  <b-container>
    <transition name="fade-out" v-if="showTable">
      <div class="tbl" v-if="showTable">
        <b-row>
          <b-col>
            <b-form-group horizontal label="Filter">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6" class="my-1">
            <b-form-group horizontal label="Per page">
              <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          v-cloak
          responsive
          :fields="trainersTableFields"
          :items="trainersTableNoNull"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <template slot="tid" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTrainer', params: { id: row.value } }"
              >{{ row.value }}</b-link
            >
          </template>
          <template slot="trainer_name" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              @click="showTrainerDetails(row.item.tid, row.item.trainer_name)"
              >{{ row.value }}</b-link
            >
          </template>
        </b-table>
        <download-button
          :export="trainersTableNoNull"
          :file="file"
        ></download-button>
      </div>
    </transition>
    <transition name="fade-in" v-if="!showTable">
      <div class="individual-trainer">
        <b-row align-h="center">
          <b-button variant="primary" @click="toggleTable"
            >Show all Trainers</b-button
          >
        </b-row>
        <b-row>
          <b-col>
            <h4 align-h="center" class="mt-4">
              <b-link
                @click.stop="stopClick"
                :to="{ name: 'EditTrainer', params: { id: trainerId } }"
                >{{ trainerName }}</b-link
              >
            </h4>
            <b-row>
              <b-table
                v-cloak
                responsive
                :fields="individualTableFields"
                :items="individualTable"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                v-if="individualTable.length && loaded"
              ></b-table>
              <h6 align-h="center" v-if="!loaded">Loading...</h6>
              <download-button
                :export="individualTable"
                :file="indFile"
                v-if="individualTable.length && loaded"
              ></download-button>
              <h6 align-h="center" v-if="!individualTable.length && loaded">
                Sorry, {{ trainerName }} doesn't have any activity to show
              </h6>
            </b-row>
          </b-col>
          <b-col>
            <h4 align-h="center" class="mt-4">
              {{ trainerName }}'s Activity Over Time
            </h4>
            <chart-trainer-activity
              v-if="loaded && individualTable.length"
              :chartData="trainerActivityData"
              :styles="activityStyles"
            ></chart-trainer-activity>
            <h6 align-h="center" v-if="!loaded">Loading...</h6>
            <h6 align-h="center" v-if="loaded && !individualTable.length">
              Sorry, {{ trainerName }} doesn't have enough activity to make a
              chart
            </h6>
          </b-col>
        </b-row>
      </div>
    </transition>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ChartTrainerActivity from '../charts/ChartTrainerActivity';
import DownloadButton from '../components/DownloadButton';

export default {
  name: 'DataTrainer',
  components: {
    ChartTrainerActivity,
    DownloadButton,
  },
  data() {
    return {
      trainersTableFields: [
        { key: 'tid', label: 'ID' },
        { key: 'trainer_name', label: 'Name', sortable: true },
        { key: 'active', label: 'Active?', sortable: true },
        { key: 'country', label: 'Country', sortable: true },
        { key: 'sch_ct', label: 'Schools', sortable: true },
        { key: 'tea_ct', label: 'Teachers', sortable: true },
        { key: 'stu_ct', label: 'Students', sortable: true },
        { key: 'co_ct', label: 'Observations', sortable: true },
        { key: 'tm_ct', label: 'Trainings', sortable: true },
        { key: 'tw_ct', label: 'Workshops', sortable: true },
      ],
      individualTableFields: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      totalRows: this.rows,
      showTable: true,
      trainerId: null,
      trainerName: '',
      loaded: false,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  methods: {
    ...mapActions({
      RESET_IND: 'dashboards/RESET_IND_TABLE',
      GET_TRAINERS_TABLE: 'dashboards/GET_TRAINERS_TABLE',
      GET_TRAINER_TABLE: 'dashboards/GET_TRAINER_TABLE',
      GET_TRAINER_ACTIVITY_CHART_DATA:
        'dashboards/GET_TRAINER_ACTIVITY_CHART_DATA',
    }),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    toggleTable() {
      this.RESET_IND();
      this.showTable = true;
    },
    async showTrainerDetails(id, name) {
      // 1. toggle something to hide the table
      this.loaded = false;
      this.showTable = false;
      this.trainerName = name;
      this.trainerId = id;

      try {
        const table = await this.GET_TRAINER_TABLE(id);
        const chart = await this.GET_TRAINER_ACTIVITY_CHART_DATA(id);
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      trainersTableNoNull: 'dashboards/getTrainersTableSansNull',
      individualTable: 'dashboards/getTrainerTable',
      trainerActivityData: 'dashboards/getTrainerActivityChartData',
    }),
    today() {
      const now = new Date();
      return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    },
    file() {
      return `${this.today}-trainers-aggregate-activity.csv`;
    },
    indFile() {
      return `${this.today}-${this.trainerName}.csv`;
    },
    activityStyles() {
      return {
        width: `${this.window.width / 3}px`,
        position: 'relative',
      };
    },
    trainersTable: {
      get() {
        return this.$store.state.dashboards.trainersTable;
      },
    },
    rows() {
      return this.trainersTableNoNull.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.trainersTableFields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.GET_TRAINERS_TABLE();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
#trainers {
  table-layout: fixed;
  width: 100%;
}

.table-wrap {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
table th,
table tr {
  text-align: center;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>
